import React, { useEffect, useRef, useState } from "react";

function ExpertiseCard({ skill }) {
  const expertiseImgRef = useRef(null);
  const cardRef = useRef(null);
  const [skillDetail, setSkillDetail] = useState(false);

  useEffect(() => {
    setSkillDetail(false);
    const card = cardRef?.current;
    const image = expertiseImgRef?.current;
    if (card) {
      card.addEventListener("mouseover", () => {
        setSkillDetail(true);
        image.style.filter = "grayscale(100%)";
      });

      card.addEventListener("mouseout", () => {
        setSkillDetail(false);
        image.style.filter = "grayscale(0%)";
      });
    }
  }, []);

  // console.log(skill, "next");
  return (
    <>
      <div
        ref={cardRef}
        id="expertise_card"
        className="relative w-60 md:w-72 h-80 md:h-96 bg-gradient-to-b from-black to-white hover:scale-95 duration-200"
      >
        <div className="w-full">
          <img
            ref={expertiseImgRef}
            id="expertiseImg"
            src={skill.img}
            alt=""
            className="mix-blend-multiply"
          />
        </div>
        <div className="absolute top-0 left-0">
          <h3 className="text-white text-xl">{skill.title}</h3>
          {skillDetail && (
            <div className="w-60 md:w-72 h-80 md:h-96 pt-5 text-white animate__animated animate__fadeInUp">
              {skill.description1.map((des, index) => {
                return (<p key={index} 
                className="text-lg mt-2">&#9679; {des}</p>);
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ExpertiseCard;
